export default "__VITE_ASSET__43746208__"